import { useEffect, useRef } from "react";

const PrestashopPage = ({ url }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === "formSubmitted") {
        // رفرش کردن iframe
        if (iframeRef.current) {
          iframeRef.current.src = iframeRef.current.src;
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      src={global.config.domain_url+url+'&content_only=true'}
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  );
};

export default PrestashopPage;
